import { render, staticRenderFns } from "./TenantUserManagementView.vue?vue&type=template&id=a80edeca"
import script from "./TenantUserManagementView.vue?vue&type=script&lang=js"
export * from "./TenantUserManagementView.vue?vue&type=script&lang=js"
import style0 from "./TenantUserManagementView.vue?vue&type=style&index=0&id=a80edeca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports